import { render, staticRenderFns } from "./BrigadeRequestsQueue.vue?vue&type=template&id=bcf1237e&scoped=true&"
import script from "./BrigadeRequestsQueue.vue?vue&type=script&lang=js&"
export * from "./BrigadeRequestsQueue.vue?vue&type=script&lang=js&"
import style0 from "./BrigadeRequestsQueue.vue?vue&type=style&index=0&id=bcf1237e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcf1237e",
  null
  
)

export default component.exports
import {QBtn,QTooltip,QTable,QIcon,QTr,QTh,QTd,QSpinnerOval,QBanner} from 'quasar'
component.options.components = Object.assign({QBtn,QTooltip,QTable,QIcon,QTr,QTh,QTd,QSpinnerOval,QBanner}, component.options.components || {})
